import Cookies from 'js-cookie';
import store from '@/store'
import { lang } from '@/utils/config.js';

const getLang = () => {
  let langCookie = Cookies.get(lang);
  let langStr;
  langCookie = langCookie ? langCookie.toLocaleLowerCase() : navigator.language.toLocaleLowerCase();
  if (langCookie.indexOf('en') >= 0) {
    langStr = 'en';
  } else if (langCookie.indexOf('zh') >= 0) {
    langStr = 'cn';
  } else {
    langStr = 'en';
  }
  localStorage.setItem('lang', langStr);
  store.commit('CHANGE_LANG', langStr);
  return langStr;
};

export default getLang;